export const API_REQUEST = 'API_REQUEST';


// WEBPACK FOOTER //
// ./src/types/apiRequestTypes.js